import React from "react";
import styled from "@emotion/styled";
import SendIcon from "@mui/icons-material/Send";

const sharestylebtn = `
  width: 100%;
  height: 45px;
  max-width: 300px;
  border-radius: 50px;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  padding: 0 1.5rem;
  align-items: center;
  color: white;
  font-weight: 500;
  font-size: 0.9rem;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
  font-family: var(--font-family);
  column-gap: 18px;
    margin: auto;
`;

const ButtonMail = styled.button`
  ${sharestylebtn}
  flex-direction: row;
  height: 52px;
  background-color: var(--color-brand-blue-main);
`;

const TextInfo = styled.p`
  font-size: 12px;
  font-weight: 500;
  color: white;
`;

interface WsButtonMailProps {
  onClick: () => void;
  email: string;
  label: string;
  style?: React.CSSProperties;
}

const WsButtonMail: React.FC<WsButtonMailProps> = ({
  onClick,
  email,
  label,
  style,
}) => {
  return (
    <ButtonMail onClick={onClick} style={style}>
      <div>
        <SendIcon />
      </div>
      <div>
        <div style={{ display: "flex", flexDirection: "column" }}>{label}</div>
        <TextInfo>{email}</TextInfo>
      </div>
    </ButtonMail>
  );
};

export default WsButtonMail;
